import PaperContactChips from 'ember-paper/components/paper-contact-chips/component';

class IconContactChips extends PaperContactChips {
  searchField = 'name';
  iconField = 'icon';
}

export default IconContactChips;
